{
  "fields": {
    "switch": {
      "off": "Non",
      "on": "Oui"
    },
    "search": {
      "placeholder": "Rechercher..."
    }
  }
}
